import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DATA_MONTHS, DATA_YEAR, getISOWeeksInMonth } from '@mavles/shared';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-week-selection',
  templateUrl: './week-selection.component.html',
  styleUrls: ['./week-selection.component.scss'],
  standalone: false
})
export class WeekSelectionComponent implements OnInit {

  @Input() selectedYear: number = new Date().getFullYear();
  @Input() selectedMonth: number = new Date().getMonth() + 1;
  selectedWeekKey: string | null = null;

  @Input() set weekStart(value: string | null | undefined) {
    if (value) {
      const date = new Date(value);
      if (!isNaN(date.getTime())) {
        this.selectedYear = date.getFullYear();
        this.selectedMonth = date.getMonth() + 1;
        this.weeks = getISOWeeksInMonth(this.selectedMonth, this.selectedYear);
        
        const y = date.getFullYear();
        let m = '' + (date.getMonth() + 1);
        let d = '' + date.getDate();
        if (m.length < 2) m = '0' + m;
        if (d.length < 2) d = '0' + d;
        const formattedStart = `${y}${m}${d}`;
        
        const found = this.weeks.find(w => w.dateKey.startsWith(formattedStart));
        if (found) {
          this.selectedWeekKey = found.dateKey;
        }
      }
    }
  }

  @Output() weekChange = new EventEmitter<{ start: string, end: string }>();

  years = DATA_YEAR;
  months = DATA_MONTHS;
  weeks: any[] = [];


  ngOnInit(): void {
    this.updateWeeks();
  }

  updateWeeks() {
    this.weeks = getISOWeeksInMonth(this.selectedMonth, this.selectedYear);
    // Try to preserve current selection if it exists in the new list
    if (this.selectedWeekKey) {
        const found = this.weeks.find(w => w.dateKey === this.selectedWeekKey);
        if (!found) {
            this.selectedWeekKey = null;
        }
    }

    // Default to current week if nothing selected
    if (!this.selectedWeekKey) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const currentWeek = this.weeks.find(w => {
            const start = new Date(w.start);
            start.setHours(0, 0, 0, 0);
            const end = new Date(w.end);
            end.setHours(23, 59, 59, 999);
            return today >= start && today <= end;
        });
        
        if (currentWeek) {
            this.selectedWeekKey = currentWeek.dateKey;
            this.onWeekSelect();
        }
    }
  }

  onMonthYearChange() {
    this.updateWeeks();
  }

  onWeekSelect() {
    const selectedWeek = this.weeks.find(w => w.dateKey === this.selectedWeekKey);
    if (selectedWeek) {
      this.weekChange.emit({
        start: this.formatToYYYYMMDD(selectedWeek.start),
        end: this.formatToYYYYMMDD(selectedWeek.end)
      });
    }
  }

  private formatToYYYYMMDD(date: Date): string {
    return formatDate(date, 'yyyy-MM-dd', 'en-US');
  }
}


